var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m8 8 6.745-6.745A.87.87 0 0 1 15.361 1v0a1.74 1.74 0 0 1 1.6 2.426L15.955 5.77c-.32.744-.479 1.117-.422 1.417a1 1 0 0 0 .424.642C16.21 8 16.616 8 17.427 8H18"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 19s1 2 3 2h7.883c1.46 0 2.191 0 2.781-.267a3 3 0 0 0 1.275-1.094c.354-.542.465-1.265.687-2.71l.538-3.493c.28-1.818.42-2.727.166-3.44a3 3 0 0 0-1.405-1.638C20.259 8 19.339 8 17.5 8v0H17M6 10l2-2M2 19v-9a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2Z"
})));
export default SvgLike;